import React from "react";
import { css } from "@linaria/core";
import Ellipsis from "@ui/Ellipsis";
import GitMergeLine from "@ui/IconV2/react/GitMergeLine";
import TooltipV2 from "@ui/TooltipV2";
import { colors, spacings } from "@ui/Theme";
import t from "../../../../i18n";
import classNames from "classnames";

interface EventNameProps {
  name: string;
  hasMultiFault: boolean;
  className?: string;
}

export const EventName = ({ name, hasMultiFault, className }: EventNameProps) => (
  <span className={classNames(eventName, className)}>
    {hasMultiFault && (
      <TooltipV2 overlay={t("project.event.type.multi_fault")}>
        <span className={multiFaultEventIcon} aria-label={t("project.event.type.multi_fault")}>
          <GitMergeLine size="s" color={colors.carbon800} aria-hidden />
        </span>
      </TooltipV2>
    )}
    <Ellipsis title={name}>{name}</Ellipsis>
  </span>
);

const eventName = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacings.xxs};
  min-width: 0;
  max-width: 100%;
`;

const multiFaultEventIcon = css`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;
